























































    import AbpBase from "../../../lib/abpbase";
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {SaveWorkSchedus,GetWorkSchedus,GetUsers} from '../../../api/dialysisProcess'
    import {GetWardList,GetShiftList} from '../../../api/specialDictionary'
    import {GetListByCode} from '../../../api/configureDictionary'
    import util from '../../../lib/util'
    import u from 'underscore'


    @Component()
    export default class  extends AbpBase {
        weekType = 0
        list:any = []
        modalShow:Boolean = false
        modalTile:any = ''
        shiftActive:any = {}
        weekList:any = [
            {handoverDate:'',weekDay:'周一'},
            {handoverDate:'',weekDay:'周二'},
            {handoverDate:'',weekDay:'周三'},
            {handoverDate:'',weekDay:'周四'},
            {handoverDate:'',weekDay:'周五'},
            {handoverDate:'',weekDay:'周六'},
            {handoverDate:'',weekDay:'周日'},
        ]
        table:any = {
            loading:false
        }
        shiftList:any = []
        userOptions:any = []
        async getUsers(){
            let res = await GetUsers({})
            this.userOptions = res.objects
        }
        //设备检测
		get detectmob() {
			if (navigator.userAgent.match(/Android/i)
				|| navigator.userAgent.match(/webOS/i)
				|| navigator.userAgent.match(/iPhone/i)
				|| navigator.userAgent.match(/iPad/i)
				|| navigator.userAgent.match(/iPod/i)
				|| navigator.userAgent.match(/BlackBerry/i)
				|| navigator.userAgent.match(/Windows Phone/i)
			) {
				return true;
			} else {
				return false;
			}
		}

        //获取班次
        async getShiftList(){
            let data = {
                input:'031'
            }
            let res = await GetListByCode(data)
            this.shiftList = res
        }
        async getData(){
            this.table.loading = true
            let data = {
                WorkType:this.weekType
            }
            let res = await GetWorkSchedus(data)
            //
            this.saveForm = res.objects;
            let group_obj= u.groupBy(res.objects,function(value:any, key:any, list:any){return list[key].userId})
            this.list = []
            this.userOptions.forEach((item:any,index:any) => {
                this.list.push({...item})
            });
            this.initWeekDay()
            this.renderCloum()
            this.table.loading = false
        }
        async save(){
            let res =  await SaveWorkSchedus(this.saveForm)
            if(res.status==1){
                this.getData()
            }
        }
        async created() {
            await this.getUsers()
            await this.getShiftList()
            this.getData()
        }
        mounted() {
        }
        column:any = []
        renderCloum(){
            this.column = [
                {
                    key: 'userName',
                    width: 150,
                    className:'tableRheard',
                    renderHeader: (h:any ,params:any)=>{
                        return h('div',{
                            style: {
                                width:'100%',
                                height:'100%',
                                position:'relative'
                            }
                        },[
                            h('span',{
                                style: {
                                    width:'100%',
                                    height:'50%',
                                    textAlign:'right',
                                    display:'block',
                                    lineHeight:'100px'
                                }
                            },'星期'),
                            h('span',{
                                style: {
                                    width:'100%',
                                    height:'50%',
                                    textAlign:'left',
                                    display:'block',
                                    lineHeight:'5px'
                                }
                            },'人员'),
                            h('div',{
                                style: {
                                    width:'215%',
                                    height:'1px',
                                    background:'#e8eaec',
                                    position:'absolute',
                                    top: '43px',
                                    left: '-75px',
                                    transform: 'rotate(34deg)'
                                }
                            })
                        ])
                    }
                }
            ]
            this.weekList.forEach((item:any) => {
                this.column.push({
                    title:item.weekDay,
                    key: 'weekDay',
                    align:'center',
                    render: (h:any,params:any)=> {
                        let text ;
                        this.saveForm.forEach((fv:any)=>{
                            if(fv.userId == params.row.userId && fv.weekDay == params.column.title){
                                text = fv.workScheduleName
                            }
                        })
                        let icon = text == '早班'?'&#xe79a;':text == '午班'?'&#xe799;':text == '晚班'?'&#xe608;':'';
                        return h('Dropdown',{
                            style: {
                                width: "129px",
                                height: '60px'
                            },
                            props: {
                                trigger: 'click',
                            },
                        },[
                            h('div',{
                                style: {
                                    width:'100%',
                                    height:'100%'
                                }
                            },[
                                h('i', {
                                    class: 'iconfont',
                                    style: {
                                        position: 'absolute',
                                        left: 0
                                    },
                                    domProps: {
                                        innerHTML: icon
                                    }
                                },icon),
                                h('span',{
                                    domProps:{
                                        innerHTML: text?text:'&nbsp;'
                                    }
                                }),
                                h('span',{
                                    style :{
                                        display: 'block',
                                        position: 'absolute',
                                        bottom: '0',
                                        height: '20px',
                                        lineHeight: '20px',
                                        left:!this.detectmob?' -30px':'0',
                                        fontSize: '14px',
                                        color: '#ccc',
                                    }
                                },this.formatDate(item.handoverDate))
                            ]),
                            h("DropdownMenu", {
                                slot: "list",
                                style: {
                                    width: "100%",
                                }
                            }, [
                                h("DropdownItem", {
                                    nativeOn: {
                                        click: () => {
                                            this.setSchedus(params)
                                        }
                                    }
                                }, "选择排班")
                            ])
                        ])
                    }
                })
            });
        }
        activeInfo:any = {}
        setSchedus(row:any){
            this.activeInfo = row
            this.saveForm.forEach((item:any,index:any) => {
                if(row.row.userId == item.userId && row.column.title == item.weekDay){
                    this.activeInfo.editIndex = index
                    this.activeInfo.edit = true
                }
            });
            this.modalTile = `${row.row.userName}本周(${row.column.title})`
            this.modalShow = true
        }

        //
        saveForm:any = []
        primary(){

            if(!this.shiftActive.id){
                this.modalShow = false
                return false
            }
            if(this.activeInfo.edit){
                this.saveForm[this.activeInfo.editIndex].workSchedule = this.shiftActive.id
                this.saveForm[this.activeInfo.editIndex].workScheduleName = this.shiftActive.text
            }else{
                this.list.forEach((item:any) => {
                    if(item.userId == this.activeInfo.row.userId){
                        this.saveForm.push({
                            handoverDate:this.weekList[this.activeInfo.column._index-1].handoverDate,
                            weekDay : this.activeInfo.column.title,
                            userId : item.userId,
                            workSchedule : this.shiftActive.id,
                            workScheduleName : this.shiftActive.text
                        })
                    }
                });
            }
           
            console.log(this.saveForm)
            this.renderCloum()
            this.modalShow = false
            this.shiftActive = {}
        }
        //获取时间
        initWeekDay(){
            let now = new Date();
            let weekIndex =  now.getDay();
            this.weekList.forEach((item:any,index:any) => {
                let i =  !this.weekType ? index - (weekIndex-1) : index - (weekIndex-8);
                item.handoverDate = new Date(now.getTime() + 24*60*60*1000*i);
            });
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/workSchedus/index.vue